import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { createMuiTheme, useTheme } from "@material-ui/core/styles"
import DocomoLogo from "assets/images/DocomoLogo.svg"
import DocomoFinancialLogo from "assets/images/DocomoFinancialLogo.png"
import { Grid } from "@material-ui/core"

const useStyles = makeStyles(
  theme => ({
    logo: {
      display: "block",
      height: "37px",
      width: "auto",
      [theme.breakpoints.down("xs")]: {
        height: "30px",
      },
    },
  }),
  { defaultTheme: createMuiTheme() }
)

const HeaderLogo = props => {
  const theme = useTheme()
  const classes = useStyles(theme)
  return (
    <Grid container direction="row" alignItems="center" wrap="nowrap">
      <img src={DocomoLogo} alt="docomotitle" className={classes.logo} />
      <img
        src={DocomoFinancialLogo}
        alt="docomofinancialtitle"
        className={classes.logo}
        {...props}
      />
    </Grid>
  )
}

export default HeaderLogo
